import React from 'react';
import { Button } from 'react-bootstrap';
import { Registration } from '../../../types/registration';
import { calculateNights, formatDateWithDay, getNightsDisplayText } from './utils/registrationUtils';

interface StayDetailsCardProps {
  registration: Registration;
  onEditClick: () => void;
}

const StayDetailsCard: React.FC<StayDetailsCardProps> = ({
  registration,
  onEditClick
}) => {
  const nights = calculateNights(registration?.campDates?.arrivalDate, registration?.campDates?.departureDate);
  
  return (
    <div className="card mb-3">
      <div className="card-body p-3">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h6 className="card-title mb-0" style={{ fontWeight: 'bold', color: '#333', borderBottom: '2px solid #007bff', paddingBottom: '0.5rem' }}>
            Stay Details ({getNightsDisplayText(nights)})
          </h6>
          <Button variant="primary" size="sm" onClick={onEditClick}>
            Edit
          </Button>
        </div>
        
        <div className="row" style={{ marginBottom: '-5px' }}>
          <div className="col-4">
            <strong>Start Date:</strong>
          </div>
          <div className="col-8">
            {formatDateWithDay(registration?.campDates?.arrivalDate)}
          </div>
        </div>
        
        <div className="row">
          <div className="col-4">
            <strong>End Date:</strong>
          </div>
          <div className="col-8">
            {formatDateWithDay(registration?.campDates?.departureDate)}
          </div>
        </div>
      </div>
    </div>
  );
};

export default StayDetailsCard;

